import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { GetDataDTO } from "../../schema/Common/GetDataDTO";
import { CustomFieldsSelectValuesDTO } from "../../schema/Subscriptions/CustomFieldsSelectValuesDTO";

@Injectable({
    providedIn: "root"
})
export class ApiCustomFieldsService {
    private relativePath = `${environment.subscriptions.url}/api/v1/subscription`;

    constructor(private httpClient: HttpClient) {}

    public GetSelectValues(
        subscriptionId: string,
        fieldId: string,
        skip: number,
        limit: number,
        find: string
    ): Observable<GetDataDTO<CustomFieldsSelectValuesDTO>> {
        let params = new HttpParams().set("skip", skip.toString()).set("limit", limit.toString());

        if (find) params = params.set("find", find);

        return this.httpClient.get<GetDataDTO<CustomFieldsSelectValuesDTO>>(
            `${this.relativePath}/${subscriptionId}/custom-fields/${fieldId}/select-value`,
            {
                params: params
            }
        );
    }
}
